// src/components/Auth/PostRegistrationHandler.jsx
import React, { useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const PostRegistrationHandler = React.memo(() => {
  const { user } = useAuth();

  const handlePostRegistration = useCallback(async () => {
    if (!user) return;

    // Check if user came from pricing page with an explicit PAID plan selection
    const storedPlan = localStorage.getItem('selectedPlan');
    
    // For no-card trials, we DON'T redirect to checkout
    // Users will add payment when their trial expires or if they upgrade early
    if (storedPlan) {
      console.log('User registered from pricing page, but no checkout redirect needed for free trial');
      // Clear the stored plan
      localStorage.removeItem('selectedPlan');
    }

    // Normal trial users just proceed to dashboard (no checkout needed)
    console.log('User registered successfully - trial active, no payment required');
  }, [user]);

  useEffect(() => {
    handlePostRegistration();
  }, [handlePostRegistration]);

  return null;
});

PostRegistrationHandler.displayName = 'PostRegistrationHandler';

export default PostRegistrationHandler;